import type { TimeSeriesChartDateRange } from '@/features/time-series-chart/types/TimeSeriesChartDateRange.types';
import type { TimeWindowMicros } from '@/features/time-series-chart/types/TimeWindow.types';
import { toTimeMicros } from '@/shared/utils/timeConversion';

/** Placeholder for a disabled query: Orval requires the params, `enabled` keeps them off the wire. */
export const DISABLED_TIME_WINDOW: TimeWindowMicros = { fromTimeMicros: 0, toTimeMicros: 0 };

const MICROS_PER_MILLISECOND = 1_000;

export function getTimeWindowMicros(dates: TimeSeriesChartDateRange | undefined): TimeWindowMicros | undefined {
  if (!dates) {
    return undefined;
  }

  return {
    fromTimeMicros: toTimeMicros(dates.from),
    toTimeMicros: toTimeMicros(dates.to),
  };
}

/** Backend samples are in microseconds; the chart works in epoch milliseconds. */
export function microsToTimestamp(timeMicros: number): number {
  return timeMicros / MICROS_PER_MILLISECOND;
}

export function isInTimeWindow(timeMicros: number, { fromTimeMicros, toTimeMicros }: TimeWindowMicros): boolean {
  return timeMicros >= fromTimeMicros && timeMicros < toTimeMicros;
}
